import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { ErrorComponent } from './shared/components/error/error.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { errorGuard } from './shared/guards/error/error.guard';

const routes: Routes = [
  {
    path: 'secure',
    loadChildren: () =>
      import('../app/secure/secure.module').then((m) => m.SecureModule),
    canActivate: [errorGuard, AuthGuard],
    data: { Title: 'Secure' },
  },
  { path: 'error', component: ErrorComponent, data: { Title: 'Error' } },
  { path: '', pathMatch: 'full', redirectTo: 'secure' },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
    data: { Title: 'Page Not Found' },
  },
];

@NgModule({
  imports: [
    ErrorComponent,
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
